import { useCallback, useEffect, useRef } from "react";
import { makeProfit } from "../../redux/user/make-profit.handler";
import { useDispatch } from "../../hooks";

export const RealtimeProfit = () => {
    const profitIntervalIdRef = useRef<NodeJS.Timeout | null>(null);
    const dispatch = useDispatch();

    const releaseProfitTimer = () => {
        if (!profitIntervalIdRef.current)
            return;

        clearInterval(profitIntervalIdRef.current);
        profitIntervalIdRef.current = null;
    }

    const timerFunction = useCallback(() => dispatch(makeProfit()), [dispatch]);

    useEffect(() => {
        if (!profitIntervalIdRef.current)
            profitIntervalIdRef.current = setInterval(timerFunction, 15 * 60 * 1000); // 15 minutes

        return () => releaseProfitTimer();
    }, [timerFunction]);

    return <></>;
}